import { useEffect } from 'react';
import triggerGoogleTagManagerCustomEvent from '../../common/utils/triggerGoogleTagManagerCustomEvent';
import GtmEvents from '../constants/gtmEvents';
import findAssociatedLabel from '../utils/findAssociatedLabel';

function useGtmToggleIntentTracking() {
  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      // Check if target is an Element (covers both HTMLElement and SVGElement)
      // This is important because clicking on icons/SVGs inside buttons should still track the button
      if (!(e.target instanceof Element)) {
        return;
      }

      const toggleElement = e.target.closest('button[role="switch"]');

      if (toggleElement instanceof HTMLElement) {
        const label = findAssociatedLabel(toggleElement);

        triggerGoogleTagManagerCustomEvent(GtmEvents.TOGGLE_CLICK, {
          action: 'intent',
          label,
          old_state: toggleElement.getAttribute('aria-checked') === 'true' ? 'enabled' : 'disabled',
        });
      }
    };

    document.addEventListener('click', handleClick, { capture: true });
    return () => document.removeEventListener('click', handleClick, { capture: true });
  }, []);
}

export default useGtmToggleIntentTracking;
